import {
	CORE_LOAD_ALL_SERVICE_REQUEST,
	CORE_LOAD_ALL_SERVICE_SUCCESS,
	CORE_LOAD_ALL_SERVICE_FAILURE,

	CORE_CHANGE_PREPARE_TO_SEND_REQUEST,
	CORE_CHANGE_PREPARE_TO_SEND_SUCCESS,
	CORE_CHANGE_PREPARE_TO_SEND_FAILURE,

	SET_ERROR,
} from '../../types'

const initialState = {
	hasError: false,
	isLoading: false,
	error: null,
}
export default (state = initialState, action) => {

	switch (action.type) {
		case CORE_LOAD_ALL_SERVICE_REQUEST:
		case CORE_CHANGE_PREPARE_TO_SEND_REQUEST:
			return {
				...state,
				isLoading: true,
				hasError: false,
				error: null,
			}
		case CORE_LOAD_ALL_SERVICE_SUCCESS:
		case CORE_CHANGE_PREPARE_TO_SEND_SUCCESS:
			return {
				...state,
				isLoading: false,
				hasError: false,
				error: null,
			}

		case CORE_LOAD_ALL_SERVICE_FAILURE:
		case CORE_CHANGE_PREPARE_TO_SEND_FAILURE:
			let returnData = {
				...state,
				isLoading: false,
				hasError: true,
				error: action.payload.data,
			}
			return returnData

		case SET_ERROR:
			return {
				...state,
				hasError: action.hasError,
				error: action.error
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/features/ui/reducer.js